export const CMS1500Box1 = {
    MEDICARE: 'MEDICARE',
    MEDICAID: 'MEDICAID',
    TRICARE: 'TRICARE',
    CHAMPVA: 'CHAMPVA',
    GROUP_HEALTH_PLAN: 'GROUP_HEALTH_PLAN',
    FECA_BLK_LUNG: 'FECA_BLK_LUNG',
    OTHER: 'OTHER',
};

export const CMS1500Box1Labels = {
    [CMS1500Box1.MEDICARE]: 'Medicare',
    [CMS1500Box1.MEDICAID]: 'Medicaid',
    [CMS1500Box1.TRICARE]: 'TRICARE',
    [CMS1500Box1.CHAMPVA]: 'CHAMPVA',
    [CMS1500Box1.GROUP_HEALTH_PLAN]: 'Group Health Plan',
    [CMS1500Box1.FECA_BLK_LUNG]: 'FECA BLK LUNG',
    [CMS1500Box1.OTHER]: 'Other',
};

export const CMS1500Box24EPSDT = {
    EMPTY: '',
    Y: 'Y',
    N: 'N',
};

export const CMS1500Box24EPSDTLabels = {
    [CMS1500Box24EPSDT.EMPTY]: 'None',
    [CMS1500Box24EPSDT.Y]: 'Y',
    [CMS1500Box24EPSDT.N]: 'N',
};
